import { generateTestId } from "@client-shared";

export const setOrdersTableTestId = (identifier: string): string =>
  generateTestId("OrdersTable", identifier);
